import { recommendationTypes } from '@haaretz/s-consts';

export default function getRecommendationType(origin?: string | null) {
  const recommendationType = (origin && recommendationTypes[origin]) || origin;

  return recommendationType ?? undefined;
}
